import Link, { LinkProps } from "next/link";
import { AnchorHTMLAttributes, forwardRef, ReactNode } from "react";

type LinkOptionalProps = (Omit<LinkProps, 'href'> & { href: string | undefined | null }) & AnchorHTMLAttributes<HTMLAnchorElement> & {
    enabled?: boolean;
    children: ReactNode;
};

const LinkOptional = forwardRef<HTMLAnchorElement, LinkOptionalProps>(
    ({ enabled = true, href, children, ...linkProps }, ref) => {
        if (!enabled ||!href) return <>{children}</>;

        return (
            <Link ref={ref} href={href} {...linkProps}>
                {children}
            </Link>
        );
    }
);

LinkOptional.displayName = 'LinkOptional';
export default LinkOptional;